import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useNavigate } from 'react-router';

const LogoutButton = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    localStorage.removeItem('token');
    localStorage.removeItem('hotelData');
    navigate('/login');
    handleClose();
  };

  return (
    <>
      <Button variant="contained" sx={{ ml: 3 }} onClick={handleClickOpen}>
        Cerrar Sesión
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Confirmación de Cierre de Sesión</DialogTitle>
        <DialogContent>¿Estás seguro de que deseas cerrar sesión?</DialogContent>
        <DialogActions>
          <Button onClick={handleLogout} color="primary">
            Confirmar
          </Button>
          <Button onClick={handleClose}>Cancelar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default LogoutButton;
